import './fonts.css'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter as Router } from 'react-router-dom';
import App from './App.tsx'
import { UserProvider } from './contexts/UserContext'
import { NotificationProvider } from './contexts/NotificationContext'
import PrivyProvider from './providers/PrivyProvider'



createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Router>
      <PrivyProvider>
        <NotificationProvider>
          <UserProvider>
            <App />
          </UserProvider>
        </NotificationProvider>
      </PrivyProvider>
    </Router>
  </StrictMode>,
)
